import "./App.css";
import Form from "./Components/form";
import React from "react";
function App() {
  const [value, setValue] = React.useState({ imgUrl: "", name: "" });
  const handleValue = (e, name) => {
    setValue({ imgUrl: e, name });
  };
  return (
    <div className="App">
      <Form searchImg={handleValue} />
      <div className="img">
        {value.imgUrl.length > 0 && (
          <h2>
            Displaying the image of
            <b>
              <a href={value.imgUrl} target="_blank" rel="noopener">
                {value.name.toUpperCase()}
              </a>
            </b>
          </h2>
        )}
        <img src={value.imgUrl} alt="" />
      </div>
    </div>
  );
}

export default App;
